import { Route } from 'react-router-dom';
import Incidents from '@/modules/common/pages/Incidents.tsx';
import Meetings from '@/modules/common/pages/Meetings.tsx';
import SecretManager from '@/modules/common/pages/SecretManager.tsx';
import SecretManagerVault from '@/modules/common/pages/SecretManagerVault.tsx';
import AdminComplianceDashboardWrapper from '@/modules/admin-dashboard/components/AdminComplianceDashboardWrapper.tsx';
import AIChat from '@/modules/admin-dashboard/pages/AIChat.tsx';
import AuditLog from '@/modules/admin-dashboard/pages/AuditLog.tsx';
import BatchReports from '@/modules/admin-dashboard/pages/BatchReports.tsx';
import Businesses from '@/modules/admin-dashboard/pages/Businesses.tsx';
import Client from '@/modules/admin-dashboard/pages/Client.tsx';
import Clients from '@/modules/admin-dashboard/pages/Clients.tsx';
import Dashboard from '@/modules/admin-dashboard/pages/Dashboard.tsx';
import Department from '@/modules/admin-dashboard/pages/Department.tsx';
import Documents from '@/modules/admin-dashboard/pages/Documents.tsx';
import FixedReports from '@/modules/admin-dashboard/pages/FixedReports.tsx';
import Form from '@/modules/admin-dashboard/pages/Form.tsx';
import Forms from '@/modules/admin-dashboard/pages/Forms.tsx';
import { FormsByTag } from '@/modules/admin-dashboard/pages/FormsByTag.tsx';
import OnDemandReports from '@/modules/admin-dashboard/pages/OnDemandReports.tsx';
import Registers from '@/modules/admin-dashboard/pages/Registers.tsx';
import Tasks from '@/modules/admin-dashboard/pages/Tasks.tsx';
import TemplateReports from '@/modules/admin-dashboard/pages/TemplateReports.tsx';
import UserManagement from '@/modules/admin-dashboard/pages/UserManagement.tsx';

export const adminDashboardPaths = {
  static: {
    dashboard: '/admin/dashboard',
    departments: '/admin/departments',
    management: '/admin/user-management',
    forms: '/admin/forms',
    tasks: '/admin/tasks',
    fixedReports: '/admin/reports/fixed',
    onDemandReports: '/admin/reports/on-demand',
    templateReports: '/admin/reports/template',
    batchReports: '/admin/reports/batch',
    incidents: '/admin/events',
    registers: '/admin/registers',
    meetings: '/admin/meetings',
    organizationsSettings: '/admin/organizations-settings',
    documents: '/admin/documents',
    aiChat: '/admin/ai-chat',
    clients: '/admin/clients',
    auditLog: '/admin/audit-log',
    secretManager: '/admin/secret-manager',
  },
  dynamic: {
    form(id?: string | number) {
      return `/admin/forms/${id || ':id'}`;
    },
    formsByTag(tagId?: string | number) {
      return `/admin/forms-by-tag/${tagId || ':id'}`;
    },
    taskCategory(category?: string) {
      return `/admin/tasks/${category || ':category'}`;
    },
    client(id?: string | number) {
      return `/admin/clients/${id || ':id'}`;
    },
    secretVault(vaultId?: string | number) {
      return `/admin/secret-manager/${vaultId || ':vaultId'}`;
    },
  },
};

export const getDashboardRoutes = () => {
  return (
    <Route element={<AdminComplianceDashboardWrapper />}>
      <Route path={adminDashboardPaths.static.dashboard} element={<Dashboard />} />
      <Route path={adminDashboardPaths.static.departments} element={<Department />} />
      <Route path={adminDashboardPaths.static.management} element={<UserManagement />} />
      <Route path={adminDashboardPaths.static.forms} element={<Forms />} />
      <Route path={adminDashboardPaths.static.clients} element={<Clients />} />
      <Route path={adminDashboardPaths.dynamic.client()} element={<Client />} />
      <Route path={adminDashboardPaths.dynamic.form()} element={<Form />} />
      <Route path={adminDashboardPaths.static.tasks} element={<Tasks />} />
      <Route path={adminDashboardPaths.dynamic.taskCategory()} element={<Tasks />} />
      <Route path={adminDashboardPaths.static.fixedReports} element={<FixedReports />} />
      <Route path={adminDashboardPaths.static.onDemandReports} element={<OnDemandReports />} />
      <Route path={adminDashboardPaths.static.templateReports} element={<TemplateReports />} />
      <Route path={adminDashboardPaths.static.batchReports} element={<BatchReports />} />
      <Route path={adminDashboardPaths.static.incidents} element={<Incidents />} />
      <Route path={adminDashboardPaths.static.registers} element={<Registers />} />
      <Route path={adminDashboardPaths.static.meetings} element={<Meetings />} />
      <Route path={adminDashboardPaths.dynamic.formsByTag()} element={<FormsByTag />} />
      <Route path={adminDashboardPaths.static.organizationsSettings} element={<Businesses />} />
      <Route path={adminDashboardPaths.static.documents} element={<Documents />} />
      <Route path={adminDashboardPaths.static.aiChat} element={<AIChat />} />
      <Route path={adminDashboardPaths.static.auditLog} element={<AuditLog />} />
      <Route path={adminDashboardPaths.static.secretManager} element={<SecretManager />} />
      <Route path={adminDashboardPaths.dynamic.secretVault()} element={<SecretManagerVault />} />
    </Route>
  );
};
